module.exports = __webpack_public_path__ + "img/新希望地产.7fd55246.png";